var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-top" },
    [
      _c("div", {
        staticClass: "home-top-bg",
        style: { background: _vm.bg_list[_vm.bg_index] },
      }),
      _vm._v(" "),
      _vm.sogouApp
        ? _c("header", [
            _c("a", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false",
                },
              ],
              staticClass: "back",
              attrs: {
                id: "goback",
                href: "javascript:history.go(-1)",
                uigs: "head_back",
              },
            }),
            _vm._v(" "),
            _c("h1", [_vm._v("搜狗视频")]),
            _vm._v(" "),
            _vm.showBarrierFree
              ? _c(
                  "a",
                  {
                    staticClass: "sgapp-easy-access",
                    attrs: {
                      href: "javascript:void(0);",
                      onclick: "aria.start()",
                      clickhide: "false",
                      openText: "打开无障碍",
                      closeText: "关闭无障碍",
                    },
                  },
                  [_vm._v("无障碍")]
                )
              : _vm._e(),
          ])
        : _c("header", { staticClass: "header-home" }, [
            _c("a", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false",
                },
              ],
              staticClass: "back",
              attrs: {
                id: "goback",
                href: "javascript:history.go(-1)",
                uigs: "head_back",
              },
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "search-input",
                attrs: { href: _vm.hotSuggHref, uigs: "head_search" },
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.placeholder))]),
                _vm._v(" "),
                _c("span", { staticClass: "txt" }, [_vm._v("搜索")]),
              ]
            ),
            _vm._v(" "),
            _vm.showBarrierFree
              ? _c(
                  "a",
                  {
                    staticClass: "easy-access",
                    attrs: {
                      href: "javascript:void(0);",
                      onclick: "aria.start()",
                      clickhide: "false",
                      openText: "打开无障碍",
                      closeText: "关闭无障碍",
                    },
                  },
                  [_vm._v("无障碍")]
                )
              : _vm._e(),
          ]),
      _vm._v(" "),
      _vm.banner && _vm.banner.length > 0
        ? _c("banner-item", {
            attrs: { list: _vm.banner },
            on: { change: _vm.bannerChange },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.nav && _vm.nav.length > 0
        ? _c(
            "ul",
            { staticClass: "home-nav" },
            _vm._l(_vm.nav, function (item, index) {
              return _c("li", { key: index }, [
                _c(
                  "a",
                  {
                    class: item.icon,
                    attrs: {
                      href: item.playurl,
                      uigs: "out_home_tag_" + index,
                    },
                  },
                  [_c("h4", [_vm._v(_vm._s(item.tag_name))])]
                ),
              ])
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }